/**
 * gen90-sticky-bar.js
 *
 * Reveals the mobile sticky purchase bar once the hero has scrolled out of view,
 * and hides it again while the final CTA is on screen or the buy box is focused.
 * Mobile-only is enforced in CSS (display:none >=900px); this file only toggles
 * an `is-visible` class. Self-contained: no theme.js dependency, wired to
 * shopify:section:load / :unload with AbortController teardown and an init guard.
 * Keeps below the theme cart drawer's z-index (bar is z-index 900).
 */
(function () {
  'use strict';

  function initBar(root) {
    var bar = root.matches && root.matches('[data-gen90-sticky]') ? root : root.querySelector('[data-gen90-sticky]');
    if (!bar || bar.getAttribute('data-gen90-init') === 'true') {
      return;
    }
    bar.setAttribute('data-gen90-init', 'true');

    var controller = window.AbortController ? new AbortController() : null;
    bar.__lpAbort = controller;
    var observers = [];
    bar.__lpObs = observers;

    var heroPassed = false;
    var finalVisible = false;
    var buyFocused = false;

    function update() {
      bar.classList.toggle('is-visible', heroPassed && !finalVisible && !buyFocused);
    }

    var hero = document.getElementById('hero-sentinel');
    var final = document.getElementById('final-cta-sentinel');

    if ('IntersectionObserver' in window) {
      if (hero) {
        var io1 = new IntersectionObserver(function (entries) {
          var e = entries[0];
          heroPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
          update();
        }, { threshold: 0 });
        io1.observe(hero);
        observers.push(io1);
      } else {
        heroPassed = true;
      }
      if (final) {
        var io2 = new IntersectionObserver(function (entries) {
          finalVisible = entries[0].isIntersecting;
          update();
        }, { threshold: 0 });
        io2.observe(final);
        observers.push(io2);
      }
    } else {
      heroPassed = true;
    }

    if (controller) {
      document.addEventListener('focusin', function (e) {
        if (e.target.closest && e.target.closest('[data-gen90-buybox]')) {
          buyFocused = true;
          update();
        }
      }, { signal: controller.signal });
      document.addEventListener('focusout', function () {
        setTimeout(function () {
          var a = document.activeElement;
          buyFocused = !!(a && a.closest && a.closest('[data-gen90-buybox]'));
          update();
        }, 0);
      }, { signal: controller.signal });
    }

    update();
  }

  function teardown(root) {
    var bar = root.querySelector ? root.querySelector('[data-gen90-sticky]') : null;
    if (root.matches && root.matches('[data-gen90-sticky]')) { bar = root; }
    if (!bar) { return; }
    if (bar.__lpObs) { bar.__lpObs.forEach(function (o) { o.disconnect(); }); bar.__lpObs = null; }
    if (bar.__lpAbort) { bar.__lpAbort.abort(); bar.__lpAbort = null; }
    bar.removeAttribute('data-gen90-init');
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-gen90-sticky]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { if (e.target) { teardown(e.target); } });
})();
